import Api from '@/services/Api'
import { ToastProgrammatic as Toast } from 'buefy'


export default {

    //aluno
    AddAluno(uuid,params) {
        return Api().put(`/aluno/${uuid}/addcredito`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    //corretor
    AddCorretor(uuid,params) {
        return Api().put(`/corretor/${uuid}/addcredito`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    RmCorretor(uuid,params) {
        return Api().put(`/corretor/${uuid}/rmcredito`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    //escola
    AddEscola(uuid,params) {
        return Api().put(`/escola/${uuid}/addcredito`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    RmEscola(uuid,params) {
        return Api().put(`/escola/${uuid}/rmcredito`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },

    //turma
    AddTurma(uuid,params) {
        return Api().put(`/turma/${uuid}/addcredito`, params).then(response => response.data,
            error => {
                if (error.message) {
                    Toast.open({
                        duration: 5000,
                        message: error.message,
                        position: 'is-top-right',
                        type: 'is-danger'
                    })
                }
                return Promise.reject(error.message)
            })
    },


}
